// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"b792280e","787":"22e3b59d"}[chunkId] + ".chunk.js";
};